<template>
  <div class="p-3">
    <h4>{{ item.name }}</h4>
  </div>
</template>

<script>
export default {
  name: "LaborerCell",
  props: {
    item: {
      type: Object,
      required: true
    }
  }
};
</script>

<style scoped></style>
